import React, { useMemo } from "react";
import Section from "./Blocks/Section";
import Tabs from "./Blocks/Tabs";
import DocumentBlock from "./Blocks/Document";
import {
   ECLRichTextViewer,
   ECLComments,
   ECLDynamicMap,
   AskSourceOne,
   ECLActionButton,
   ECLObjectBlock,
   ECLObjectInstanceBlock,
} from "../";
import Columns from "./Blocks/Columns";
import ReportBlock from "./Blocks/Report";
import ECLTableBlock from "./Blocks/ECLTableBlock/ECLTableBlock";
import ECLParameters from "./Blocks/ECLParameters/ECLParameters";
import ECLFormBlock from "./Blocks/ECLFormBlock/ECLFormBlock";
import ECLSliderBlock from "./Blocks/ECLSliderBlock/ECLSliderBlock";
import ECLGridPlotBlock from "./Blocks/ECLGridPlotBlock/ECLGridPlotBlock";
import ECLExplorerBlock from "./Blocks/ECLExplorerBlock/ECLExplorerBlock";
import ECLSearchBlock from "./Blocks/ECLSearchBlock/ECLSearchBlock";
import ECLSpreadSheetBlock from "./Blocks/ECLSpreadSheetBlock/ECLSpreadSheetBlock";
import ECLFormFieldBlock from "./Blocks/ECLFormFieldBlock/ECLFormFieldBlock";
import ECLPivotTable from "./Blocks/ECLPivotTable/ECLPivotTable";

export default function ECLBlock(props) {
   let linkAddress;
   if (props.headlist.length > 1) {
      linkAddress = "link-" + props.parent;
   } else {
      linkAddress = "link-";
   }

   let parentObject = props.headlist.at(-1).split("_")[0];
   const rootID = props.headlist.at(-1); //Last item on the headlist is your root
   const sessionID = props.flatDoc[rootID].session;

   const component = props.block.type;
   const componentJSX = (component) => {
      switch (component) {
         case "Object Instance":
            return (
               <ECLObjectInstanceBlock {...props} parentObject={parentObject} />
            );
         case "Section":
            return <Section {...props} parentObject={parentObject} />;
         // Wrapped "Rich Text" case inside of braces to remove ESLint error no-case-declarations.
         case "Rich Text": {
            const viewer = useMemo(
               () => (
                  <ECLRichTextViewer
                     textAsMarkdown={props.block.data.text}
                     project_id={props.project}
                     flatDoc={props.flatDoc}
                     setFlatDoc={props.setFlatDoc}
                     navigateTo={props.navigateTo}
                     setNavigateTo={props.setNavigateTo}
                     parentObject={parentObject}
                  />
               ),
               [props.block.data.text, props.flatDoc],
            );
            return (
               <div className="blockument-rich-text-container">{viewer}</div>
            );
         }
         case "Tabs":
            return <Tabs {...props} parentObject={parentObject} />;
         case "Columns":
            return <Columns {...props} parentObject={parentObject} />;
         case "Document":
            return <DocumentBlock {...props} parentObject={parentObject} />;
         case "Report":
            return <ReportBlock {...props} parentObject={parentObject} />;
         case "Comments":
            return (
               <div>
                  <ECLComments
                     sectionId={props.block.data.comment_section_id}
                     projectId={props.project}
                     parentObject={parentObject}
                  />
               </div>
            );
         case "Dynamic Map":
            return <ECLDynamicMap {...props} parentObject={parentObject} />;
         case "Action Button":
            return (
               <ECLActionButton
                  block={props.block}
                  parentObject={parentObject}
               />
            );
         case "Visualization":
            return <p>This Plot Block is Deprecated</p>;
         case "AI":
            return <AskSourceOne {...props} parentObject={parentObject} />;
         case "Create Object":
            return <ECLObjectBlock parentObject={parentObject} />;
         case "Table":
            return <ECLTableBlock {...props} parentObject={parentObject} />;
         case "Plot":
            return <p>This Plot Block is Deprecated</p>;
         case "Parameter":
            return <ECLParameters {...props} parentObject={parentObject} />;
         case "Form":
            return <ECLFormBlock {...props} parentObject={parentObject} />;
         case "Slider": // To be deleted at later date (2/8/24 MG)
            return <ECLSliderBlock {...props} parentObject={parentObject} />;
         case "Plot3":
            return (
               <ECLGridPlotBlock
                  {...props}
                  parentObject={parentObject}
                  plotConfigs={props.block.data.plotConfigs}
                  sessionID={sessionID}
               />
            );
         case "Explorer":
            return <ECLExplorerBlock {...props} parentObject={parentObject} />;
         case "Search":
            return <ECLSearchBlock {...props} parentObject={parentObject} />;
         case "Spreadsheet":
            return (
               <ECLSpreadSheetBlock {...props} parentObject={parentObject} />
            );
         case "FormField":
            return <ECLFormFieldBlock {...props} parentObject={parentObject} />;
         case "PivotTable":
            return <ECLPivotTable {...props} parentObject={parentObject} />;
         default:
            console.error(`Unsupported Block type: ${component}`);
            return null;
      }
   };

   return (
      <div id={`${linkAddress}${props.flatKey}`}>{componentJSX(component)}</div>
   );
}
